import moment from 'moment-timezone';
import dateAndTimeConstants from 'utils/dateAndTimes/constants';

/*
 * @returns next rounded hour after the given margin.
 */
export const getNextRoundedHour = ({
  time,
  margin,
  timezone = moment.tz.guess(),
}) => {
  const hourPlusMargin = moment(time).tz(timezone).add(margin, 'minutes');
  return hourPlusMargin
    .add(1, 'hour')
    .set({ minute: 0, seconds: 0, milliseconds: 0 });
};

export const getHoursDifference = (startDate, endDate) => {
  return moment.duration(endDate.diff(startDate)).asHours();
};

/**
 *
 * @param startTime string HH:mm
 * @param endTime string HH:mm
 */
export const getHoursDifferenceByTimes = (startTime, endTime) => {
  const startDate = moment(startTime, 'HH:mm');
  const endDate = moment(endTime, 'HH:mm');
  return getHoursDifference(startDate, endDate);
};

export const resetTime = (date) => {
  return date.clone().hours(0).minutes(0).seconds(0).milliseconds(0);
};

/**
 *
 * @param date moment date
 * @param time string HH:mm
 */
export const setTime = (date, time = '00:00') => {
  const [hours, minutes] = time.split(':');
  return resetTime(date.clone()).hours(hours).minutes(minutes);
};

/**
 * @param date YYYY-MM-DD
 * @param daysAmount
 * @returns {string}
 */
export const addDays = (date, daysAmount) => {
  return moment(date).add(daysAmount, 'days').format('YYYY-MM-DD');
};

export const getDayDiff = (date1, date2) =>
  Math.abs(
    moment(date2).startOf('day').diff(moment(date1).startOf('day'), 'days')
  );

export const thresholdToRound = (
  stepInMinutes = dateAndTimeConstants.CONSTANTS_FOR_RULES.STEPS_IN_MINUTES
) =>
  dateAndTimeConstants.CONSTANTS_FOR_RULES.MINUTES_IN_AN_HOUR - stepInMinutes;
